import { render, staticRenderFns } from "./Hero3.vue?vue&type=template&id=e2950f44&scoped=true&"
var script = {}
import style0 from "./Hero3.vue?vue&type=style&index=0&id=e2950f44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2950f44",
  null
  
)

export default component.exports